module.exports = __webpack_public_path__ + "static/media/wDark_day_cloudy.21c016af.svg";